<template>
  <layout :drawerShow="_isDesktop()" :drawerWidth="350">
    <template slot="nav"></template>
    <template slot="drawer">
      <v-form ref="searchform" v-if="searchform" @submit.prevent="loadData">
        <v-row dense>

          <v-subheader light class="pa-0 mt-3 mb-0 ml-1"
          >Date de séjour
          </v-subheader>
          <v-col class="pr-1" cols="6">
            <smart-picker
                v-model="searchform.tripDateStart"
                :stopDate="searchform.tripDateStop"
                :inputOpts="{ label: $t('begin') }"
            />
          </v-col>
          <v-col cols="6">
            <smart-picker
                v-model="searchform.tripDateStop"
                :startDate="searchform.tripDateStart"
                :inputOpts="{ label: $t('end') }"
            />
          </v-col>

          <v-col cols="12" class="pr-1 mt-2">
            <smart-select
                v-model="searchform.selectedHotels"
                item-text="name"
                item-value="id"
                label="Hotels"
                :default-select-all="true"
                :all-is-same-as-empty="true"
                :loading="loadingHotels"
                :items="hotels"
                :chip-style="{ width: '120px' }"
            ></smart-select>
          </v-col>

          <v-col cols="12" class="pr-1">
            <smart-multi-select
                v-model="searchform.selectedSites"
                label="Sites"
                :items="sites"
                :all-is-same-as-empty="true"
                :default-select-all="true"
            ></smart-multi-select>
          </v-col>
        </v-row>

        <smart-btn type="submit" block primary class="mt-2" :loading="loading"
        >Rechercher
        </smart-btn
        >
        <smart-btn
            block
            tertiary
            @click.native="
            clearSearchform();
            loadData();
          "
        >Réinitialiser la recherche
        </smart-btn
        >

        <v-skeleton-loader v-if="loading"/>
      </v-form>
    </template>
    <template slot="content">
      <v-container fluid>
        <div class="text-right mb-2">
          <v-btn href="#"
                 @click="exportCsv('bookingListTable', hotels.find(h=> h.id == searchform.selectedHotels[0]).name)"
                 small>
            <v-icon small round>mdi-file-download</v-icon>
            export
          </v-btn>
        </div>
        <v-data-table
            ref="bookingListTable"
            :loading="loading"
            :headers="headers"
            :items="bookings"
            no-data-text="Il n'y a pas de dossiers disponible"
            :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'rows-per-page-options': 'Lignes par page',
          }"
            class="elevation-1 tbl"
        >
          <template #body="{ items }">
            <tbody>
            <tr
                v-for="(item, idx) in items"
                :key="idx"
                @click="openBookingResume(item.bookingId)"
            >
              <td class="text-left font-weight-regular">
                  <span class="caption  text--darken-1">
                    {{ item.bookingId }}
                  </span>
              </td>
              <td class="text-left font-weight-regular">
                  <span class="caption  text--darken-1">
                    {{ item.siteName }}
                  </span>
              </td>
              <td class="text-left font-weight-regular">
                  <span class="caption  text--darken-1">
                    {{ formStringGuest(item) }}
                  </span>
              </td>

              <td class="text-left">
                <div class="font-weight-regular">
                  {{
                    _capitalize(_parseAndFormatDate(
                        item.checkin,
                        datePatternConfig.serverLocalDateTime,
                        datePatternConfig.en.localDate
                    ))
                  }}
                </div>
              </td>
              <td class="text-left">
                <div class="font-weight-regular">
                  {{
                    _capitalize(_parseAndFormatDate(
                        item.checkout,
                        datePatternConfig.serverLocalDateTime,
                        datePatternConfig.en.localDate
                    ))
                  }}
                </div>
              </td>
              <td class="text-left">
                <div class="font-weight-regular">
                  {{ item.duration }} nights
                </div>
              </td>
              <td>
                <div class="caption">
                  {{
                    formStringRooms(item)
                  }}

                </div>
              </td>
              <td class="text-left">
                {{
                  item.mealplans.join(",")
                }}

              </td>
              <td class="text-left" style="max-width:150px">
                <div class="font-weight-regular">
                  {{ item.comments != null ? item.comments.replaceAll("\\n"," ") : '-' }}
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-container>

      <smart-dialog
          v-model="bookingDialog.dialog"
          :title="'Dossier ' + bookingDialog.bookingId"
      >
        <booking-drawer-content
            :showprices="false"
            :showlinks="false"
            :booking="bookingDialog.selectedBooking"
        ></booking-drawer-content>
      </smart-dialog>
    </template>
  </layout>
</template>

<script>
import Layout from "@/views/Layout";
import {get, post} from "@/utils/api";
import Vue from "vue";
import Availability from "@/components/commons/Availability";
import SmartSelect from "../../components/commons/SmartSelect";
import SiteLabel from "../../components/commons/SiteLabel";
import BookingDrawerContent from "../../components/commons/BookingDrawerContent";
import ExportMixin from "@/components/mixins/ExportMixin";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";

export default {
  components: {
    SmartMultiSelect,
    SiteLabel,
    SmartSelect,
    Availability,
    Layout,
    BookingDrawerContent,
  },
  mixins: [ExportMixin],
  data() {
    return {
      bookingDialog: {
        bookingId: null,
        dialog: false,
        selectedBooking: null,
      },
      loading: true,
      headers: [
        {text: "Réf.", value: "bookingId", align: "left"},
        {text: "AGENCY", value: "siteName", align: "left"},
        {text: "GUESTS", value: "guests"},
        {text: "CHECK-IN", value: "checkin"},
        {text: "CHECK-OUT", value: "checkout"},
        {text: "STAY", value: "stayDuration"},
        {text: "ROOM CATEGORY", value: "rooms"},
        {text: "MEAL PLAN", value: "mealplan"},
        {text: "COMMENTS", value: "comments"},
      ],
      bookings: [],
      loadingHotels: false,
      hotels: [],
      sites: [],
      //searchform
      defaultSearchform: {
        selectedSites: [],
        selectedNetworks: [],
        selectedAgencies: [],
        selectedChains: [],
        selectedHotels: [],
        selectedDestinations: [],
        client: null,
        ref: null,
        tripDateStart: this._nowFormatted("dd/MM/yyyy"),
        tripDateStop: this._nowFormatted("dd/MM/yyyy"),
        bookingDateStart: null,
        bookingDateStop: null,
        paxOnPlaceDateStart: null,
        paxOnPlaceDateStop: null,
        bookingStatus: ["booked"],
        supplierStatus: ["confirmed"],
        paymentStatus: null,
        destinationId: null,
        tags: [],
      },
      searchform: null,

      valid: false,
      rowsPerPageItems: [{text: "Tous", value: -1}, 50, 100],
      widgetBus: new Vue(),
    };
  },
  created() {
    setTimeout(async () => {
      await get("/api/search/hotels").json((hotels) => this.hotels = hotels);
      await get("/api/search/sites").json((sites) => {
        this.sites = sites;
        this.defaultSearchform.selectedSites = this.sites.map((s) => s.id);
      });
      this.clearSearchform();
      this.initSearchform();
      this.loadData();
    }, 1);
  },
  mounted() {
  },
  computed: {},
  watch: {},
  methods: {
    loadData() {
      this.loading = true
      //set qs
      window.history.pushState(
          "",
          "",
          "?search=" + JSON.stringify(this.searchform)
      );

      this.getBookings();
    },
    async getBookings() {
      const withDesti = {
        ...this.searchform,
        ...{destinationId: this.currentUser.defaultDestiId},
      };
      await post("/api/extranet/bookings/hoteliers", withDesti).json(
          (data) => (this.bookings = data)
      );
      this.loading = false
    },
    initSearchform() {
      const qs = new URLSearchParams(window.location.search);
      const search = (() => {
        try {
          return JSON.parse(qs.get("search"));
        } catch (e) {
          return null;
        }
      })();

      if (search) {
        console.log(search)
        this.searchform = search;
      } else this.clearSearchform();
    },
    clearSearchform() {
      this.searchform = {...this.defaultSearchform};
    },

    formStringRooms(item) {
      const rooms = item.roomCategory.reduce((prev, acc) => {
        if (prev[acc] == null) {
          prev[acc] = 1
        } else {
          prev[acc]++;
        }
        return prev
      }, {})

      return Object.keys(rooms).map(key => {
        if (rooms[key] > 1) {
          return `${rooms[key]}x ${key}`
        } else {
          return key
        }
      }).join(', ')
    },

    formStringGuest(item) {
      const objAgeClasses = item.guests.reduce((prev, acc) => {
        if (prev[acc] == null) {
          prev[acc] = 1
        } else {
          prev[acc]++;
        }
        return prev
      }, {})

      const stringFormatted = Object.keys(objAgeClasses).map(key => `${objAgeClasses[key]} ${key}`).join(', ')


      return `${item.guestsName} (${stringFormatted})`
    },

    //
    openBookingResume(bookingId) {
      if (bookingId < 300000) {
        window
            .open(
                "https://admin.smart-be.com/SmartBe-admin/on-place-agent/bookings?bookingid=" +
                bookingId,
                "_blank"
            )
            .focus();
      } else {
        const url = `/api/booking/${bookingId}`;
        get(url)
            .json((r) => {
              this.bookingDialog.bookingId = bookingId;
              this.bookingDialog.selectedBooking = r.data;
              this.bookingDialog.selectedBooking.prestations = this.bookingDialog.selectedBooking.prestations.filter(p => p.status == 'booked' && p.supplierStatus == 'confirmed');
            })
            .then(() => {
              this.bookingDialog.dialog = true;
            });
      }
    },
    renderHotelWithDesti(hotelWithDesti) {
      return hotelWithDesti
          .map((hotel) => {
            return `
						<div class="text-xs-left font-weight-regular">${hotel[0]}: ${hotel[1]}</div>
					`;
          })
          .join("");
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-subheader {
  width: 100%;
  height: 20px;
  color: #616161;
}

td:hover {
  cursor: pointer;
}
</style>











